/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
    PalReauthSubmissionStatusToJSONTyped,
} from './PalReauthSubmissionStatus';
import type { PalReauthSubmissionTimingState } from './PalReauthSubmissionTimingState';
import {
    PalReauthSubmissionTimingStateFromJSON,
    PalReauthSubmissionTimingStateFromJSONTyped,
    PalReauthSubmissionTimingStateToJSON,
    PalReauthSubmissionTimingStateToJSONTyped,
} from './PalReauthSubmissionTimingState';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';
import type { PalReauthSubmissionListEntryTimExecution } from './PalReauthSubmissionListEntryTimExecution';
import {
    PalReauthSubmissionListEntryTimExecutionFromJSON,
    PalReauthSubmissionListEntryTimExecutionFromJSONTyped,
    PalReauthSubmissionListEntryTimExecutionToJSON,
    PalReauthSubmissionListEntryTimExecutionToJSONTyped,
} from './PalReauthSubmissionListEntryTimExecution';
import type { PalReauthSubmissionListEntryLead } from './PalReauthSubmissionListEntryLead';
import {
    PalReauthSubmissionListEntryLeadFromJSON,
    PalReauthSubmissionListEntryLeadFromJSONTyped,
    PalReauthSubmissionListEntryLeadToJSON,
    PalReauthSubmissionListEntryLeadToJSONTyped,
} from './PalReauthSubmissionListEntryLead';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalReauthSubmissionListEntryPayer } from './PalReauthSubmissionListEntryPayer';
import {
    PalReauthSubmissionListEntryPayerFromJSON,
    PalReauthSubmissionListEntryPayerFromJSONTyped,
    PalReauthSubmissionListEntryPayerToJSON,
    PalReauthSubmissionListEntryPayerToJSONTyped,
} from './PalReauthSubmissionListEntryPayer';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
    PalReauthSubmissionStatusInfoToJSONTyped,
} from './PalReauthSubmissionStatusInfo';

/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntry
 */
export interface PalReauthSubmissionListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    pal_submission_id: string;
    /**
     * 
     */
    status: PalReauthSubmissionStatus;
    /**
     * 
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    previous_status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    external_id?: string | null;
    /**
     * 
     */
    next_review_date?: string | null;
    /**
     * 
     */
    timing_state: PalReauthSubmissionTimingState;
    /**
     * 
     */
    can_revert_status: boolean;
    /**
     * True when this is the lead's active cycle, `pal_reauths` and `pcc_data_relay_enabled` are both on for the lead's facility, and the lead has a PCC patient id, so the concurrent review must pass through the `review` status in the Re-Auth tab, where the submission package is built, before it can be Submitted. Inactive cycles are always false, since the wizard only works on the active cycle. While this is true, `PUT /pal-reauth-submissions/{id}` refuses `status=submitted` from `not_started`, `incomplete` or `review`; only `POST /pal-reauth-submissions/{id}/submit` sets it. Set on `GET /pal-reauth-submissions` rows and on the `latest_pal_reauth` of `GET /screener-leads/{lead_id}/pal-submission`; treat it as false when absent.
     */
    requires_review_transition?: boolean;
    /**
     * 
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    submitted_at?: Date | null;
    /**
     * 
     */
    submitted_by_user_id?: string | null;
    /**
     * 
     */
    submitted_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    date_created: Date;
    /**
     * 
     */
    lead?: PalReauthSubmissionListEntryLead;
    /**
     * 
     */
    payer?: PalReauthSubmissionListEntryPayer;
    /**
     * 
     */
    auth_platform_name?: string | null;
    /**
     * 
     */
    is_oon?: boolean;
    /**
     * 
     */
    tim_execution?: PalReauthSubmissionListEntryTimExecution;
    /**
     * 
     */
    submission_mode?: string;
    /**
     * 1-based re-auth cycle number for the lead (oldest cycle is 1)
     */
    cycle_number?: number;
}



/**
 * Check if a given object implements the PalReauthSubmissionListEntry interface.
 */
export function instanceOfPalReauthSubmissionListEntry(value: object): value is PalReauthSubmissionListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('pal_submission_id' in value) || value['pal_submission_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('timing_state' in value) || value['timing_state'] === undefined) return false;
    if (!('can_revert_status' in value) || value['can_revert_status'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionListEntryFromJSON(json: any): PalReauthSubmissionListEntry {
    return PalReauthSubmissionListEntryFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'status': PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': json['status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': json['previous_status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'external_id': json['external_id'] === undefined ? undefined : json['external_id'] === null ? null : json['external_id'],
        'next_review_date': json['next_review_date'] === undefined ? undefined : json['next_review_date'] === null ? null : json['next_review_date'],
        'timing_state': PalReauthSubmissionTimingStateFromJSON(json['timing_state']),
        'can_revert_status': json['can_revert_status'],
        'requires_review_transition': json['requires_review_transition'] == null ? undefined : json['requires_review_transition'],
        'case_manager': json['case_manager'] == null ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'status_updated_by_user': json['status_updated_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'submitted_at': json['submitted_at'] === undefined ? undefined : json['submitted_at'] === null ? null : (parseDateTime(json['submitted_at'])),
        'submitted_by_user_id': json['submitted_by_user_id'] === undefined ? undefined : json['submitted_by_user_id'] === null ? null : json['submitted_by_user_id'],
        'submitted_by_user': json['submitted_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['submitted_by_user']),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'lead': json['lead'] == null ? undefined : PalReauthSubmissionListEntryLeadFromJSON(json['lead']),
        'payer': json['payer'] == null ? undefined : PalReauthSubmissionListEntryPayerFromJSON(json['payer']),
        'auth_platform_name': json['auth_platform_name'] === undefined ? undefined : json['auth_platform_name'] === null ? null : json['auth_platform_name'],
        'is_oon': json['is_oon'] == null ? undefined : json['is_oon'],
        'tim_execution': json['tim_execution'] == null ? undefined : PalReauthSubmissionListEntryTimExecutionFromJSON(json['tim_execution']),
        'submission_mode': json['submission_mode'] == null ? undefined : json['submission_mode'],
        'cycle_number': json['cycle_number'] == null ? undefined : json['cycle_number'],
    };
}

export function PalReauthSubmissionListEntryToJSON(json: any): PalReauthSubmissionListEntry {
    return PalReauthSubmissionListEntryToJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryToJSONTyped(value?: PalReauthSubmissionListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'pal_submission_id': value['pal_submission_id'],
        'status': PalReauthSubmissionStatusToJSON(value['status']),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value['status_info']),
        'previous_status_info': PalReauthSubmissionStatusInfoToJSON(value['previous_status_info']),
        'external_id': value['external_id'],
        'next_review_date': value['next_review_date'],
        'timing_state': PalReauthSubmissionTimingStateToJSON(value['timing_state']),
        'can_revert_status': value['can_revert_status'],
        'requires_review_transition': value['requires_review_transition'],
        'case_manager': PalReauthCaseManagerToJSON(value['case_manager']),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['status_updated_by_user']),
        'submitted_at': value['submitted_at'] == null ? value['submitted_at'] : serializeDateTime(value['submitted_at']),
        'submitted_by_user_id': value['submitted_by_user_id'],
        'submitted_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['submitted_by_user']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'lead': PalReauthSubmissionListEntryLeadToJSON(value['lead']),
        'payer': PalReauthSubmissionListEntryPayerToJSON(value['payer']),
        'auth_platform_name': value['auth_platform_name'],
        'is_oon': value['is_oon'],
        'tim_execution': PalReauthSubmissionListEntryTimExecutionToJSON(value['tim_execution']),
        'submission_mode': value['submission_mode'],
        'cycle_number': value['cycle_number'],
    };
}

